module.exports = __webpack_public_path__ + "fonts/TitilliumWeb-Bold.eot";